import { makeStyles } from "@material-ui/core";
import { activityColors } from "features/activity/activityConsts";

export const activityTableStyle = makeStyles((theme) => ({
    errorIcon: {
        fill: 'white',
    },
    errorIconWrapper: {
        background: '#fd8f8f',
    },
    errorTooltip: {
        padding: '2em',
        width: '500px'
    },
    title: {
        fontWeight: 550,
        fontSize: 17
    },
    activityTableCount: {
        padding: '0.2em 0.5em',
        marginLeft: '0.5em',
        borderRadius: '5px',
        fontWeight: '400',
        fontSize: '0.8em',
        color: theme.palette.primary.contrastText,
        background: theme.palette.primary.main,
        minWidth: '3em',
        textAlign: 'center'
    },
    dot: {
        height: '10px',
        width: '10px',
        borderRadius: '50%'
    },
    activityTableCount1: {
        background: activityColors[1]
    },
    activityTableCount2: {
        background: activityColors[2]
    },
    activityTableCount3: {
        background: activityColors[3]
    },
    activityTableCount4: {
        background: activityColors[4]
    },
    activityTableCount5: {
        background: activityColors[5]
    },
    activityTableCount6: {
        background: activityColors[6]
    },
    activityTableCount7: {
        background: activityColors[7]
    },
    activityTableCount8: {
        background: activityColors[8]
    },
    activityTableCount9: {
        background: activityColors[9]
    },
    activityTableCount10: {
        background: activityColors[10]
    },
    activityTableCount11: {
        background: activityColors[11]
    },
    activityTableCount12: {
        background: activityColors[12]
    },
    activityTableCountAttention: {
        background: '#E8A48E'
    },
    buttonIcon: {
        width: '10'
    },
    flaggedRow: {
        position: 'relative',
        "&::before": {
            content: "''",
            background: '#ffff0029',
            position: "absolute",
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
        },
    },
    listContainer: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'space-between',
        position: 'relative',
    },
    listWrapper: {
        flex: 6,
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '0.7em',
        width: '100%',
        overflowX: 'auto',
    },
    header: {
        padding: '0 1rem',
        paddingBottom: '1rem',
        marginBottom: '0.5rem',
    },
    titleContainer: {
        display: "flex",
        flexDirection: "row"
    },
    title: {
        display: "flex",
        alignItems: "center",
        fontWeight: 500,
        fontSize: 20,
        paddingLeft: 8,
        marginRight: 32
    },
    activityListConfirmWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '0.5rem 0.5rem',
        height: 1000
    },
    activityListConfirm: {
        width: '600px',
        padding: '0.5rem'
    },
    card: {
        padding: '1em 2em',
        height: '100%',
        boxShadow: '2px 3px 10px #d7d6d6',
    },
    summaryCard: {
        padding: '1em 2em',
        height: '100%',
        boxShadow: '2px 3px 10px #d7d6d6',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: theme.palette.primary.main,
    },
    titleIcon: {
        margin: '0.5rem'
    },
    title: {
        fontWeight: 600,
        fontSize: '1.2rem'
    },
    sectionTitle: {
        color: theme.palette.primary.main,
        fontWeight: 500,
        fontSize: '1.1rem',
        marginBottom: '0.5rem'
    },
    summaryItem: {
        padding: '0.5rem 0 0.5rem 1rem',
        minHeight: '45px',
    },
    summaryItemBorder: {
        padding: '0.5rem 0 0.5rem 1rem',
        minHeight: '45px',
        border: '1px solid lightGrey',
        borderRadius: '4px',
    },
    autoComplete: {
        margin: '0.5rem 0 ',
        padding: '0.5rem 0 0.5rem 0.5rem',
        color: theme.palette.common.darkText,
        border: '1px solid lightGrey',
        borderRadius: '4px',

        '&.MuiOutlinedInput-adornedEnd': {
            backgroundColor: theme.palette.background.default,
        },
        '&.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root': {
            padding: '0 !important',
        },
        '&.MuiAutocomplete-inputRoot': {
            padding: '0 !important',
        },
        '&.Mui-disabled': {
            opacity: 0.5,
        },
        '& fieldset': {
            border: 'none'
        }
    },
    itemLabel: {
        fontWeight: 600,
    },
    itemIcon: {
        paddingRight: '1em',
    },
    mapWrapper: {
        height: '100%',
        minHeight: '300px'
    },
    actionWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    actionButton: {
        margin: '0.5rem',
        minWidth: '150px'
    },
    activityLabel: {
        marginLeft: '0.5rem',
        fontWeight: 500
    },
    filter: {
        marginRight: '0.5rem'
    },
    filterIconWhite: {
        '& path': {
            stroke: theme.palette.primary.main,
        },
        '& svg': {
            stroke: theme.palette.primary.main,
        }
    },
    alertWrapper: {
        margin: '0.1rem 0 0.5rem'
    },
    otherActivity: {
        color: theme.palette.common.darkText,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid lightGrey',
        borderRadius: '4px',
    },
    activityPricingVin: {
        width: '200px'
    },
    activityPricing: {
        fontWeight: 450,
        marginTop: '0.5rem'
    },
    btn: {
        whiteSpace: 'normal',
        width: '11em'
    },
    input: {
        marginBottom: 16
    },
    emptyIndicator: {
        color: theme.palette.text.disabled,
    },
}));